export const load = (apiUrl, apiCode) =>
  new Promise(resolve => {
    window.upReady = resolve;

    (function(u, p, l, i, f, t, b, j) {
      u['UpLiftPlatformObject'] = f;
      // eslint-disable-next-line no-unused-expressions
      (u[f] =
        u[f] ||
        function() {
          (u[f].q = u[f].q || []).push(arguments);
          // eslint-disable-next-line no-sequences
        }),
        (u[f].l = 1 * new Date());
      // eslint-disable-next-line no-unused-expressions,no-sequences
      (b = p.createElement(l)), (j = p.getElementsByTagName(l)[0]);
      b.async = 1;
      b.src = i + '?id=' + t;
      j.parentNode.insertBefore(b, j);
      let o = window.location.host.match(/[\w-]+\.\w{2,3}(:\d+)?$/);
      if (o) {
        o = o[0];
      }
      u[f]('create', t, o);
    })(window, document, 'script', apiUrl, 'up', apiCode);
  });
